import fetch from '../util/fetch'
import { backendUrl } from '../config'

export const getClients = () =>
  fetch({
    url: `${backendUrl}/clients`,
    method: 'GET',
  }).then((res) => res.data)
